import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';
export const daysOffsService = {
    create,
    getAll,
    update,
    deleteDayOff
};

function create(data)
{
    return axios.post('/api/services/app/DaysOffs/CreateDayOff',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getAll(data)
{
    return axios.get('/api/services/app/DaysOffs/GetAllDaysOff', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function update(data)
{
    return axios.put('/api/services/app/DaysOffs/UpdateDayOff',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteDayOff(id)
{
    return axios.delete('/api/services/app/DaysOffs/DeleteDayOff', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}

